<template>
  <v-tooltip
    :bottom="position === 'bottom'"
    :right="position === 'right'"
    :left="position === 'left'"
    :top="position === 'top'"
    :open-on-hover="isOpenOnHover"
    :open-on-click="isOpenOnClick"
    :content-class="`help-content pa-4 ${className} ${position} ${theme}`"
    :disabled="isDisabled"
  >
    <template #activator="{ on }">
      <v-btn
        small
        depressed
        plain
        icon
        retain-focus-on-click
        :class="buttonClass"
        @click="handleClick(on)"
        v-on="on"
        @blur="on.blur"
      >
        <PtrIcon
          :icon="iconName"
          :height="iconHeight || 18"
          :editable-color="iconColor !== undefined || strokeColor !== undefined"
          :color="iconColor"
          :stroke-color="strokeColor"
        />
      </v-btn>
    </template>
    <span v-if="content" class="d-flex flex-column">
      <img v-if="content.imageLink" :src="content.imageLink" alt="Content Image" />
      <div v-if="content.header" class="hoverable-header mb-2">{{ content.header }}</div>
      <div v-if="content.description" class="paragraph-s">{{ content.description }}</div>
      <div v-if="content.link">
        <a :href="content.link.href" target="_blank" rel="noopener">{{ content.link.text }}</a>
      </div>
    </span>
    <slot name="html-header"></slot>
    <slot name="html-content"></slot>
  </v-tooltip>
</template>

<script>
import PtrIcon from "@/components/shared/PtrIcon.vue";

export default {
  components: { PtrIcon },
  props: {
    content: Object,
    className: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "right"
    },
    iconHeight: String,
    iconName: { type: String, default: "question-mark" },
    iconColor: String,
    strokeColor: String,
    isDisabled: {
      type: Boolean,
      default: false
    },
    isOpenOnClick: {
      type: Boolean,
      default: true
    },
    isOpenOnHover: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: "dark"
    }
  },
  methods: {
    handleClick(on) {
      if (on && typeof on.click === "function") {
        on.click();
      }
    }
  }
};
</script>
<style lang="scss">
.help-content {
  width: 296px;
  background-color: var(--v-neutral-darken4);
  color: var(--v-white-base);
  box-shadow: 0px 4px 8px rgba(23, 25, 28, 0.16);
  border-radius: 8px;
  pointer-events: all;
  opacity: 1;
  overflow: inherit !important; // that's important to make the pseudo-element visible outside the main container
  z-index: 20;
  &.fit-content {
    width: fit-content;
  }
  &.hidden {
    display: none !important;
  }

  &::before {
    content: "";
    position: absolute;
    top: calc(50% - 10px);
    bottom: 0;
    left: -8px;
    z-index: 21;
    width: 0px;
    height: 0px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid var(--v-neutral-darken4);
    box-sizing: border-box;
    pointer-events: none;
  }

  &.bottom::before {
    content: "";
    position: absolute;
    top: -18px;
    bottom: auto;
    left: calc(50% - 10px);
    border-top: 10px solid var(--v-neutral-darken4);
    border-bottom: 10px solid transparent;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    transform: rotate(180deg);
    box-sizing: border-box;
    pointer-events: none;
  }

  &.left::before {
    left: auto;
    right: -18px;
    border-left: 10px solid var(--v-neutral-darken4);
    border-right: 10px solid transparent;
    pointer-events: none;
  }
  .hoverable-header {
    font-weight: #{$font-weight-medium};
    line-height: #{$line-height-10};
    font-size: #{$font-size-6};
  }
  &.light {
    background-color: var(--v-background-lighten5);
    color: var(--v-foreground-darken2);
    &.bottom::before {
      border-top: 10px solid var(--v-background-lighten5);
      border-bottom: 10px solid transparent;
      border-right: 10px solid transparent;
      border-left: 10px solid transparent;
    }
    &.left::before {
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid var(--v-background-lighten5);
      border-left: 10px solid transparent;
    }
  }

  a {
    color: var(--v-white-base);
  }

  &.higher-z-index {
    z-index: 300 !important;
  }
}
</style>
